// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3H752","title":"Info_title__37k9B","selects":"Info_selects__3tcNV","requiredAsterisk":"Info_requiredAsterisk__3Neq_"};